<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full">
  <!-- Content -->
  <div class="flex flex-col flex-auto">
    <div  [ngStyle]="{'background-color': backgroundColor}" class="w-full max-md:p-0 p-5 pb-0 overflow-hidden">
      <main>
        <header *ngIf='showHeader' class="bg-white rounded-[15px] p-[6.5px_8px] mb-6 max-md:mb-[28px] header">
          <div class="flex-container flex justify-between items-center w-full">
            <div class="left-block flex gap-[50px] items-center max-2xl:gap-[20px]">
              <button class="header__burger"><span class="line"></span></button>
              <div class="ml-[24px] max-2xl:ml-[0] logo">
                <a routerLink='/'><img src="/assets/images/landing/logo.svg" alt="Логотип"></a>
              </div>
              <div class="nav flex gap-[40px] max-2xl:gap-[20px]">
                <a class="nav-link js--scroll-to" routerLink='/'>Главная</a>
                <a class="nav-link" routerLink='/about-us'>О нас</a>
                <a class="nav-link js--scroll-to" routerLink='/news'>Новости</a>
              </div>
            </div>
            <div class="right-block flex gap-[10px] items-center">
              <header-user></header-user>
            </div>
          </div>
        </header>
        <router-outlet></router-outlet>
        <footer class="pt-12 pb-8 footer border-t border-gray-100">
          <div class="container px-4 md:px-6">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-6">
              <!-- Блок логотипа и компании -->
              <div class="flex flex-col gap-4">
                <div class="flex items-center gap-4 mb-2">
                  <img src="/assets/images/landing/logo.svg" alt="Логотип" class="w-32 md:w-auto">
                </div>
                <div class="text-sm text-gray-500 leading-relaxed">
                  <p class="font-semibold text-gray-900 mb-1 uppercase tracking-wider">ООО «СММОФ»</p>
                  <p>ОГРН 1256600009610</p>
                  <p>ИНН 6670528380</p>
                  <p class="mt-2 text-xs">
                    620078, г. Екатеринбург, пер. Автоматики, стр. 1, офис 211/пом. 51,55
                  </p>
                </div>
              </div>

              <!-- Блок О компании -->
              <div class="flex flex-col gap-4">
                <h3 class="font-bold text-gray-900 uppercase tracking-wider text-sm">О компании</h3>
                <nav class="flex flex-col gap-2 text-sm text-gray-600">
                  <a routerLink="/about-us" class="hover:text-primary transition-colors">О нас</a>
                  <a routerLink="/news" class="hover:text-primary transition-colors">Новости</a>
                </nav>
              </div>

              <!-- Блок Документы -->
              <div class="flex flex-col gap-4">
                <h3 class="font-bold text-gray-900 uppercase tracking-wider text-sm">Документация</h3>
                <nav class="flex flex-col gap-2 text-sm text-gray-600">
                  <a routerLink="/regulations" class="hover:text-primary transition-colors">Политика обработки персональных данных</a>
                  <a routerLink="/privacy-policy" class="hover:text-primary transition-colors">Условия использования</a>
                </nav>
              </div>

              <!-- Блок Социальные сети -->
              <div class="flex flex-col gap-4 lg:items-end">
                <div class="flex flex-col gap-4 w-full lg:max-w-xs">
                  <h3 class="font-bold text-gray-900 uppercase tracking-wider text-sm">Социальные сети</h3>
                  <div class="flex gap-4">
                    <a href="https://t.me/smmof" target="_blank" class="flex items-center justify-center w-10 h-10  transition-all duration-300 overflow-hidden" matTooltip="Telegram">
                      <img src="/assets/images/ui/other/icon-telegram-128.png" alt="Telegram" class="w-full h-full object-cover grayscale opacity-75 hover:grayscale-0 hover:opacity-100 transition-all duration-300 scale-90">
                    </a>
                    <a href="https://max.ru/id6670528380_biz" target="_blank" class="flex items-center justify-center w-10 h-10  transition-all duration-300 overflow-hidden" matTooltip="Макс">
                      <img src="/assets/images/ui/other/icon-max-128.png" alt="Макс" class="w-full h-full object-cover grayscale opacity-75 hover:grayscale-0 hover:opacity-100 transition-all duration-300 scale-90">
                    </a>
                  </div>
                </div>
              </div>

              <!-- Блок Поддержка -->
              <div class="flex flex-col gap-4 lg:items-end">
                <div class="flex flex-col gap-4 w-full lg:max-w-xs">
                  <h3 class="font-bold text-gray-900 uppercase tracking-wider text-sm">Поддержка</h3>
                  <div class="flex flex-col gap-2 text-sm text-gray-600">
                    <a href="mailto:support@smmof.ru" class="flex items-center gap-2 hover:text-primary transition-colors">
                      <mat-icon class="icon-size-4 text-gray-400" [svgIcon]="'heroicons_outline:mail'"></mat-icon>
                      support&#64;smmof.ru
                    </a>
                    <p class="text-xs text-gray-400 mt-2">Время работы: Пн-Пт 10:00 - 19:00 (МСК)</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="pt-8 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-400 leading-relaxed">
              <div class="flex flex-col md:flex-row md:items-center gap-2 md:gap-4">
                <span class="uppercase tracking-widest whitespace-nowrap">© {{currentYear}} ООО «СММОФ»</span>
                <span class="hidden md:block text-gray-300">|</span>
                <span>СММОФ® является зарегистрированным товарным знаком. Все права защищены. Использование материалов сайта без разрешения правообладателя запрещено.</span>
              </div>
            </div>
          </div>
        </footer>


      </main>
    </div>

  </div>
</div>
